import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { i18nInstance } from "../../i18n";
export var SampleAppUtilities = (function () {
    function displayStatus(message) {
        var statusElement = document.getElementById("status");
        if (statusElement) {
            statusElement.innerHTML = message;
        }
        else {
            console.warn(i18nInstance.t("error-element-ID-not-found"));
        }
    }
    function showMainUI() {
        document.querySelector(".wrapping-box-container").style.opacity = "1";
    }
    // Disable buttons to prevent hammering, fade out main interface elements, and shuffle the guidance images.
    function fadeOutMainUIAndPrepareForSession() {
        disableAllButtons();
        document.querySelector(".wrapping-box-container").style.opacity = "0";
    }
    function disableAllButtons() {
        document.querySelectorAll("button").forEach(function (button) {
            button.disabled = true;
        });
    }
    function enableAllButtons() {
        document.querySelectorAll("button").forEach(function (button) {
            button.disabled = false;
        });
    }
    function handleErrorGettingServerSessionToken() {
        showMainUI();
        if (typeof window !== "undefined") {
            var meessage = i18nInstance.t("error-element-ID-not-found");
            displayStatus(meessage);
        }
    }
    function generateUUId() {
        //@ts-ignore
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
            return (c ^
                (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
        });
    }
    function formatUIForDevice() {
        if (isLikelyMobileDevice()) {
            // Adjust button sizing
            document
                .querySelectorAll(".controls > button")
                .forEach(function (element) {
                if (element.className === "big-button") {
                    element.style.height = "40px";
                    element.style.fontSize = "18px";
                }
                else if (element.className === "medium-button") {
                    element.style.height = "30px";
                    element.style.fontSize = "14px";
                }
                element.style.width = "220px";
            });
            if (document.getElementById("controls")) {
                // Hide border around control panel
                document.getElementById("controls").style.borderColor = "transparent";
                // Hide status label text background and decrease label font size
                document.getElementById("status").style.backgroundColor =
                    "transparent";
                document.getElementById("status").style.fontSize = "12px";
            }
        }
    }
    function isLikelyMobileDevice() {
        var isMobileDeviceUA = !!/Android|iPhone|iPad|iPod|IEMobile|Mobile|mobile/i.test(navigator.userAgent || "");
        // ChromeOS/Chromebook detection.
        if (isMobileDeviceUA &&
            (navigator.userAgent.indexOf("CrOS") != -1 ||
                navigator.userAgent.indexOf("Chromebook") != -1)) {
            isMobileDeviceUA = false;
        }
        // Mobile device determination based on portrait / landscape and user agent.
        if (screen.width < screen.height || isMobileDeviceUA) {
            // Assume mobile device when in portrait mode or when determined by the user agent.
            return true;
        }
        else {
            return false;
        }
    }
    function themeCustomatizationMaat() {
        var primaryColor = "#303c59";
        var primaryColorLight = "#516799";
        var backgroundColor = "#f2f5f9";
        var btnTextColor = "#ffffff";
        var colorGray = "#b1b2b5";
        var font = "'Source Sans Pro', Helvetica, sans-serif";
        var SDKInIFrameFeatureFlag = {
            ac_ziif: "991d6c1c-5e5c-4e32-89c7-1ddfac46572e",
        };
        var defaultCustomization = new FaceTecSDK.FaceTecCustomization([
            SDKInIFrameFeatureFlag,
        ]);
        // Security Watermark Customization
        defaultCustomization.securityWatermarkCustomization.securityWatermarkImage = 1;
        // Header
        defaultCustomization.guidanceCustomization.readyScreenHeaderTextColor =
            primaryColor;
        // Vocal guidance
        defaultCustomization.vocalGuidanceCustomization.mode = 2;
        // Initial Loading Animation Customization
        defaultCustomization.initialLoadingAnimationCustomization.customAnimation =
            null;
        defaultCustomization.initialLoadingAnimationCustomization.animationRelativeScale = 1.0;
        defaultCustomization.initialLoadingAnimationCustomization.backgroundColor =
            backgroundColor;
        defaultCustomization.initialLoadingAnimationCustomization.foregroundColor =
            primaryColor;
        defaultCustomization.initialLoadingAnimationCustomization.messageTextColor =
            primaryColor;
        defaultCustomization.initialLoadingAnimationCustomization.messageFont =
            font;
        // Overlay Customization
        defaultCustomization.overlayCustomization.backgroundColor = "transparent";
        defaultCustomization.overlayCustomization.showBrandingImage = false;
        // Guidance Customization
        defaultCustomization.guidanceCustomization.backgroundColors =
            backgroundColor;
        defaultCustomization.guidanceCustomization.foregroundColor = primaryColor;
        defaultCustomization.guidanceCustomization.headerFont = font;
        defaultCustomization.guidanceCustomization.subtextFont = font;
        defaultCustomization.guidanceCustomization.buttonFont = font;
        defaultCustomization.guidanceCustomization.buttonTextNormalColor =
            backgroundColor;
        defaultCustomization.guidanceCustomization.buttonBackgroundNormalColor =
            primaryColor;
        defaultCustomization.guidanceCustomization.buttonTextHighlightColor =
            backgroundColor;
        defaultCustomization.guidanceCustomization.buttonBackgroundHighlightColor =
            primaryColorLight;
        defaultCustomization.guidanceCustomization.buttonTextDisabledColor =
            btnTextColor;
        defaultCustomization.guidanceCustomization.buttonBackgroundDisabledColor =
            colorGray;
        defaultCustomization.guidanceCustomization.buttonBorderColor =
            backgroundColor;
        defaultCustomization.guidanceCustomization.buttonBorderWidth = "2px";
        defaultCustomization.guidanceCustomization.buttonCornerRadius = "8px";
        defaultCustomization.guidanceCustomization.readyScreenOvalFillColor =
            "transparent";
        defaultCustomization.guidanceCustomization.readyScreenTextBackgroundColor =
            backgroundColor;
        defaultCustomization.guidanceCustomization.readyScreenTextBackgroundCornerRadius =
            "2px";
        defaultCustomization.guidanceCustomization.retryScreenImageBorderColor =
            primaryColor;
        defaultCustomization.guidanceCustomization.retryScreenImageBorderWidth =
            "2px";
        defaultCustomization.guidanceCustomization.retryScreenImageCornerRadius =
            "2px";
        defaultCustomization.guidanceCustomization.retryScreenOvalStrokeColor =
            primaryColor;
        defaultCustomization.guidanceCustomization.retryScreenSlideshowInterval =
            "1500ms";
        defaultCustomization.guidanceCustomization.enableRetryScreenSlideshowShuffle = false;
        // ID Scan Customization
        defaultCustomization.idScanCustomization.showSelectionScreenDocumentImage = false;
        defaultCustomization.idScanCustomization.selectionScreenDocumentImage = "";
        defaultCustomization.idScanCustomization.showSelectionScreenBrandingImage = false;
        defaultCustomization.idScanCustomization.selectionScreenBrandingImage = "";
        defaultCustomization.idScanCustomization.selectionScreenBackgroundColors =
            backgroundColor;
        defaultCustomization.idScanCustomization.reviewScreenBackgroundColors =
            backgroundColor;
        defaultCustomization.idScanCustomization.captureScreenForegroundColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.reviewScreenForegroundColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.selectionScreenForegroundColor =
            primaryColor;
        defaultCustomization.idScanCustomization.headerFont = font;
        defaultCustomization.idScanCustomization.subtextFont = font;
        defaultCustomization.idScanCustomization.buttonFont = font;
        defaultCustomization.idScanCustomization.buttonTextNormalColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.buttonBackgroundNormalColor =
            primaryColor;
        defaultCustomization.idScanCustomization.buttonTextHighlightColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.buttonBackgroundHighlightColor =
            primaryColorLight;
        defaultCustomization.idScanCustomization.buttonTextDisabledColor =
            colorGray;
        defaultCustomization.idScanCustomization.buttonBackgroundDisabledColor =
            primaryColor;
        defaultCustomization.idScanCustomization.buttonBorderColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.buttonBorderWidth = "2px";
        defaultCustomization.idScanCustomization.buttonCornerRadius = "8px";
        defaultCustomization.idScanCustomization.captureScreenTextBackgroundColor =
            primaryColor;
        defaultCustomization.idScanCustomization.captureScreenTextBackgroundBorderColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.captureScreenTextBackgroundBorderWidth =
            "2px";
        defaultCustomization.idScanCustomization.captureScreenTextBackgroundCornerRadius =
            "2px";
        defaultCustomization.idScanCustomization.reviewScreenTextBackgroundColor =
            primaryColor;
        defaultCustomization.idScanCustomization.reviewScreenTextBackgroundBorderColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.reviewScreenTextBackgroundBorderWidth =
            "2px";
        defaultCustomization.idScanCustomization.reviewScreenTextBackgroundBorderCornerRadius =
            "2px";
        defaultCustomization.idScanCustomization.captureScreenBackgroundColor =
            backgroundColor;
        defaultCustomization.idScanCustomization.captureFrameStrokeColor =
            primaryColor;
        defaultCustomization.idScanCustomization.captureFrameStrokeWidth = "2px";
        defaultCustomization.idScanCustomization.captureFrameCornerRadius = "12px";
        defaultCustomization.idScanCustomization.additionalReviewScreenBackgroundColors =
            backgroundColor;
        defaultCustomization.idScanCustomization.additionalReviewScreenForegroundColor =
            primaryColor;
        defaultCustomization.idScanCustomization.additionalReviewScreenAnimation =
            null;
        // OCR Confirmation Screen Customization
        defaultCustomization.ocrConfirmationCustomization.backgroundColors =
            backgroundColor;
        defaultCustomization.ocrConfirmationCustomization.mainHeaderDividerLineColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.mainHeaderDividerLineWidth =
            "2px";
        defaultCustomization.ocrConfirmationCustomization.mainHeaderFont = font;
        defaultCustomization.ocrConfirmationCustomization.sectionHeaderFont = font;
        defaultCustomization.ocrConfirmationCustomization.fieldLabelFont = font;
        defaultCustomization.ocrConfirmationCustomization.fieldValueFont = font;
        defaultCustomization.ocrConfirmationCustomization.inputFieldFont = font;
        defaultCustomization.ocrConfirmationCustomization.inputFieldPlaceholderFont =
            font;
        defaultCustomization.ocrConfirmationCustomization.mainHeaderTextColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.sectionHeaderTextColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.fieldLabelTextColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.fieldValueTextColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.inputFieldTextColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.inputFieldPlaceholderTextColor =
            "rgba(29, 23, 79, 0.4)";
        defaultCustomization.ocrConfirmationCustomization.inputFieldBackgroundColor =
            "transparent";
        defaultCustomization.ocrConfirmationCustomization.inputFieldBorderColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.inputFieldBorderWidth =
            "2px";
        defaultCustomization.ocrConfirmationCustomization.inputFieldCornerRadius =
            "0px";
        defaultCustomization.ocrConfirmationCustomization.showInputFieldBottomBorderOnly = true;
        defaultCustomization.ocrConfirmationCustomization.buttonFont = font;
        defaultCustomization.ocrConfirmationCustomization.buttonTextNormalColor =
            btnTextColor;
        defaultCustomization.ocrConfirmationCustomization.buttonBackgroundNormalColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.buttonTextHighlightColor =
            btnTextColor;
        defaultCustomization.ocrConfirmationCustomization.buttonBackgroundHighlightColor =
            primaryColorLight;
        defaultCustomization.ocrConfirmationCustomization.buttonTextDisabledColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.buttonBackgroundDisabledColor =
            colorGray;
        defaultCustomization.ocrConfirmationCustomization.buttonBorderColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.buttonBorderWidth = "2px";
        defaultCustomization.ocrConfirmationCustomization.buttonCornerRadius =
            "8px";
        defaultCustomization.ocrConfirmationCustomization.customScrollIndicatorAnimation =
            null;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorBackgroundNormalColor =
            primaryColor;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorBackgroundHighlightColor =
            primaryColorLight;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorForegroundNormalColor =
            backgroundColor;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorForegroundHighlightColor =
            backgroundColor;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorBorderColor =
            "transparent";
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorBorderWidth =
            "0px";
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorCornerRadius =
            "2px";
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorFont =
            font;
        defaultCustomization.ocrConfirmationCustomization.scrollIndicatorShadow =
            "none";
        defaultCustomization.ocrConfirmationCustomization.enableScrollIndicator = true;
        defaultCustomization.ocrConfirmationCustomization.enableScrollIndicatorTextAnimation = true;
        defaultCustomization.ocrConfirmationCustomization.enableFixedConfirmButton = true;
        defaultCustomization.ocrConfirmationCustomization.showScrollIndicatorImage = false;
        // Result Screen Customization
        defaultCustomization.resultScreenCustomization.backgroundColors =
            backgroundColor;
        defaultCustomization.resultScreenCustomization.foregroundColor =
            primaryColor;
        defaultCustomization.resultScreenCustomization.messageFont = font;
        defaultCustomization.resultScreenCustomization.activityIndicatorColor =
            primaryColor;
        defaultCustomization.resultScreenCustomization.customActivityIndicatorRotationInterval =
            "1s";
        defaultCustomization.resultScreenCustomization.customActivityIndicatorAnimation =
            null;
        defaultCustomization.resultScreenCustomization.resultAnimationBackgroundColor =
            "transparent";
        defaultCustomization.resultScreenCustomization.resultAnimationForegroundColor =
            primaryColor;
        defaultCustomization.resultScreenCustomization.customResultAnimationSuccess =
            null;
        defaultCustomization.resultScreenCustomization.customResultAnimationUnsuccess =
            null;
        defaultCustomization.resultScreenCustomization.showUploadProgressBar = true;
        defaultCustomization.resultScreenCustomization.uploadProgressTrackColor =
            "rgba(255, 255, 255, 0.2)";
        defaultCustomization.resultScreenCustomization.uploadProgressFillColor =
            primaryColor;
        defaultCustomization.resultScreenCustomization.animationRelativeScale = 1.0;
        // Feedback Customization
        defaultCustomization.feedbackCustomization.backgroundColor = primaryColor;
        defaultCustomization.feedbackCustomization.textColor = backgroundColor;
        defaultCustomization.feedbackCustomization.textFont = font;
        defaultCustomization.feedbackCustomization.cornerRadius = "2px";
        defaultCustomization.feedbackCustomization.shadow = "none";
        // Frame Customization
        defaultCustomization.frameCustomization.backgroundColor = backgroundColor;
        defaultCustomization.frameCustomization.borderColor = backgroundColor;
        defaultCustomization.frameCustomization.borderWidth = "0px";
        defaultCustomization.frameCustomization.borderCornerRadius = "2px";
        defaultCustomization.frameCustomization.shadow = "none";
        // Oval Customization
        defaultCustomization.ovalCustomization.strokeColor = backgroundColor;
        defaultCustomization.ovalCustomization.progressColor1 = primaryColor;
        defaultCustomization.ovalCustomization.progressColor2 = primaryColor;
        // Cancel Button Customization
        defaultCustomization.cancelButtonCustomization.location =
            FaceTecSDK.FaceTecCancelButtonLocation.Disabled;
        FaceTecSDK.setCustomization(defaultCustomization);
    }
    return {
        displayStatus: displayStatus,
        showMainUI: showMainUI,
        fadeOutMainUIAndPrepareForSession: fadeOutMainUIAndPrepareForSession,
        disableAllButtons: disableAllButtons,
        enableAllButtons: enableAllButtons,
        generateUUId: generateUUId,
        formatUIForDevice: formatUIForDevice,
        handleErrorGettingServerSessionToken: handleErrorGettingServerSessionToken,
        themeCustomatizationMaat: themeCustomatizationMaat,
    };
})();
